import { SummaryStats } from './predicted-exotics-helpers';

// Total and Pending first, then the full hit down to nothing right.
const TONES = [
  { wrapper: 'border-red-200 bg-red-50 dark:bg-red-950/20', text: 'text-red-700 dark:text-red-400' },
  { wrapper: 'border-orange-200 bg-orange-50 dark:bg-orange-950/20', text: 'text-orange-700 dark:text-orange-400' },
  { wrapper: 'border-amber-200 bg-amber-50 dark:bg-amber-950/20', text: 'text-amber-700 dark:text-amber-400' },
  { wrapper: 'border-blue-200 bg-blue-50 dark:bg-blue-950/20', text: 'text-blue-700 dark:text-blue-400' },
];
const HIT_TONE = { wrapper: 'border-emerald-200 bg-emerald-50 dark:bg-emerald-950/20', text: 'text-emerald-700 dark:text-emerald-400' };
const PENDING_TONE = { wrapper: 'border-gray-200 bg-gray-50 dark:bg-gray-950/20', text: 'text-gray-500 dark:text-gray-400' };

interface CardDef {
  key: string;
  label: string;
  value: number;
  wrapper: string;
  text: string;
}

function buildCards(stats: SummaryStats, noun: string): CardDef[] {
  const cards: CardDef[] = [
    { key: 'total', label: `Total ${noun}s`, value: stats.total, wrapper: '', text: '' },
    { key: 'pending', label: 'Pending', value: stats.pending, ...PENDING_TONE },
  ];
  for (let correct = stats.target; correct >= 0; correct--) {
    const tone = correct === stats.target ? HIT_TONE : TONES[Math.max(0, TONES.length - (stats.target - correct))] ?? TONES[0];
    cards.push({
      key: `correct-${correct}`,
      label: correct === stats.target ? `All ${stats.target} Correct` : `${correct} of ${stats.target}`,
      value: stats.counts[correct] ?? 0,
      ...tone,
    });
  }
  return cards;
}

export function ExoticStatsCards({ stats, noun }: { stats: SummaryStats; noun: string }) {
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-7">
      {buildCards(stats, noun).map((card) => (
        <div key={card.key} className={`rounded-xl border border-border bg-card p-4 shadow-sm ${card.wrapper}`}>
          <p className={`text-xs font-medium ${card.text}`}>{card.label}</p>
          <p className={`text-2xl font-semibold tabular-nums ${card.text}`}>{card.value}</p>
        </div>
      ))}
    </div>
  );
}
